import type { BandStudioApi } from './band-studio-api.service';

/**
 * The API a development build answers from instead of the server; null means the server.
 * Every build configuration uses this file except `development`, which swaps in
 * `band-studio-api.dev-source.serve.ts` (angular.json), so no other build can carry the mock.
 */
export function devBandStudioApi(): BandStudioApi | null {
  return null;
}
